import React, { useEffect, useState } from "react";
import { api, peso } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import StatusBadge from "@/components/StatusBadge";
import { Link } from "react-router-dom";

export default function OrdersPage() {
  const { branchId } = useAuth();
  const [orders, setOrders] = useState([]);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!branchId) return;
    let mounted = true;
    const load = async () => {
      try {
        const params = { branch_id: branchId };
        if (status) params.status = status;
        const { data } = await api.get("/orders", { params });
        if (mounted) setOrders(data);
      } catch (_) { if (mounted) setOrders([]); }
      finally { if (mounted) setLoading(false); }
    };
    setLoading(true);
    load();
    const iv = setInterval(load, 8000);
    return () => { mounted = false; clearInterval(iv); };
  }, [branchId, status]);

  const STATUSES = ["", "draft", "held", "submitted", "in_preparation", "ready_for_payment", "partially_paid", "paid", "voided"];

  return (
    <div className="p-6 lg:p-8" data-testid="orders-page">
      <div className="mb-6">
        <div className="tiny-label text-violet-400">Orders</div>
        <h1 className="mt-1 text-4xl font-extrabold tracking-tight">All orders</h1>
      </div>

      <div className="flex flex-wrap gap-2 mb-6">
        {STATUSES.map((s) => (
          <button
            key={s || "all"}
            data-testid={`orders-filter-${s || "all"}`}
            onClick={() => setStatus(s)}
            className={`h-9 px-3 rounded-md text-xs font-bold uppercase tracking-wider transition-colors ${
              status === s ? "bg-violet-600 text-white" : "bg-zinc-900 border border-white/10 text-zinc-400 hover:text-white"
            }`}
          >
            {s ? s.replace(/_/g, " ") : "All"}
          </button>
        ))}
      </div>

      <div className="panel-elevated overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left tiny-label border-b border-white/10">
              <th className="p-3">Order</th>
              <th className="p-3">Type</th>
              <th className="p-3">Status</th>
              <th className="p-3">Items</th>
              <th className="p-3">Server</th>
              <th className="p-3 text-right">Total</th>
              <th className="p-3">Time</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={7} className="p-6 text-center text-zinc-500">Loading…</td></tr>}
            {!loading && orders.length === 0 && <tr><td colSpan={7} className="p-8 text-center text-zinc-500">No orders match.</td></tr>}
            {orders.map((o) => (
              <tr key={o.id} className="border-b border-white/5 hover:bg-white/[0.03]" data-testid={`orders-row-${o.id}`}>
                <td className="p-3 mono font-bold text-white">{o.order_number}</td>
                <td className="p-3 text-zinc-400 capitalize">{(o.order_type || "").replace("_", " ")}</td>
                <td className="p-3"><StatusBadge status={o.status}/></td>
                <td className="p-3 text-zinc-400">{(o.items||[]).length}</td>
                <td className="p-3 text-zinc-400 mono text-xs">{o.server_user_id?.slice(-6)}</td>
                <td className="p-3 text-right font-bold text-white">{peso(o.totals?.total)}</td>
                <td className="p-3 text-zinc-500 text-xs">{new Date(o.created_at).toLocaleString("en-PH")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
